export default __webpack_public_path__ + "static/media/Principal3.3939efa0.jpeg";